import loginReducer from "./loginReducer";

const rootReducer = {
  auth: loginReducer,
};

export default rootReducer;
